import "../base.js";
import "../../models/main_menu_item.js";
import "../mixins/conditional_visibility.js";
import.meta.glob("./main_menu/items/*.{js,hbs,jst.ejs}", { eager: true });

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};

// Preserve sub-view registrations (e.g. Item, AddressItem) that
// depth-first imports already placed on the MainMenu namespace object.
const __MainMenuPrior = AppointmentBooking.Wizard.Views.Header.MainMenu;

AppointmentBooking.Wizard.Views.Header.MainMenu = class MainMenu extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.buildMenuItem = this.buildMenuItem.bind(this);
    this.updateExpandedState = this.updateExpandedState.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.items = [];
    this.items.push(this.buildMenuItem("Help"));
    this.items.push(this.buildMenuItem("Doctor"));
    this.items.push(this.buildMenuItem("Address"));
    this.items.push(this.buildMenuItem("AppointmentSlot"));

    return this.listenTo(this.model, "change:mainMenuExpanded", this.updateExpandedState);
  }

  // RENDERING

  render() {
    super.render(...arguments);
    const renderedItems = this.items.map((item) => item.render().el);
    this.replaceContents(".menu-item-container", renderedItems);

    return this;
  }

  // PRIVATE

  buildMenuItem(name, viewOptions = {}) {
    const model = new AppointmentBooking.Wizard.Models.MainMenuItem({ booking: this.model.get("booking") });
    const viewClass = this.assert.presence(
      AppointmentBooking.Wizard.Views.Header.MainMenu[`${name}Item`],
      `Unknown menu item class: ${name}`,
    );
    return new viewClass({
      ...viewOptions,
      model,
    });
  }

  updateExpandedState() {
    return this.$(".menu-item-container").toggleClass("expanded", this.model.get("mainMenuExpanded"));
  }
};

AppointmentBooking.Wizard.Views.Header.MainMenu.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Header.MainMenu.prototype.template = "header/main_menu";
AppointmentBooking.Wizard.Views.Header.MainMenu.prototype.className = "appointment-booking-wizard-main-menu";

if (__MainMenuPrior) {
  Object.assign(AppointmentBooking.Wizard.Views.Header.MainMenu, __MainMenuPrior);
}
